const isPc = (width: number) => {
  return width >= 1090;
};

export default isPc;
